export const AuthHero = () => {
  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-0 md:order-first md:h-full md:w-1/2 md:flex-none md:p-0 md:px-16">
      <div className="hidden md:block pt-8 md:pt-16">
        <div className="flex items-center gap-2 md:gap-3">
          <img
            src="/images/aayushnet_logo_light.png"
            className="h-20 rounded-lg flex-shrink-0"
            alt="AayushNet logo"
          />
          <h1
            className="text-5xl font-black tracking-wider md:text-3xl lg:text-6xl"
            style={{
              fontFamily: "'Zen Kaku Gothic Antique', sans-serif",
              lineHeight: "1.1",
            }}
          >
            <span
              style={{
                background:
                  "linear-gradient(to bottom, #5ba3ff 0%, #002d6b 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                display: "inline-block",
                lineHeight: "inherit",
                paddingBottom: "8px",
              }}
            >
              Aayush
            </span>
            <span
              style={{
                background:
                  "linear-gradient(to bottom, #66ff99 0%, #1a7a3f 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                display: "inline-block",
                lineHeight: "inherit",
                paddingBottom: "8px",
              }}
            >
              Net
            </span>
          </h1>
        </div>
      </div>
      <div className="absolute md:bottom-0 md:left-0 pb-0 md:pb-0">
        <img
          src="/images/doctor_dashboard_hero.png"
          alt="Healthcare Dashboard"
          className="h-auto object-contain object-left-bottom"
          style={{
            maxHeight: "590px",
          }}
        />
      </div>
    </div>
  );
};
